export default "__VITE_ASSET__BWxM32bh__"